const languages = [
    {
        name: "C",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/c/c-plain.svg",
    },
    {
        name: "Java",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/java/java-original.svg",
    },
    {
        name: "Python",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/python/python-original.svg",
    },
    {
        name: "C++",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/cplusplus/cplusplus-plain.svg",
    },
    {
        name: "JavaScript",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/javascript/javascript-plain.svg",
    },
    {
        name: "Ruby",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/ruby/ruby-plain.svg",
    },
    {
        name: "TypeScript",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/typescript/typescript-plain.svg",
    },
    {
        name: "C#",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/csharp/csharp-plain.svg",
    },
    {
        name: "Go",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/go/go-original.svg",
    },
    {
        name: "Php",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/php/php-plain.svg",
    },
    {
        name: "Rust",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/rust/rust-plain.svg",
    },
    {
        name: "Dart",
        link: "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/dart/dart-original.svg",
    },
];

// Front end skills obj
const frontend = [
    {
        name: "HTML",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/html5/html5-original.svg",
    },
    {
        name: "CSS",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/css3/css3-original.svg",
    },
    {
        name: "Sass",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/sass/sass-original.svg",
    },
    {
        name: "Bootstrap",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/bootstrap/bootstrap-plain.svg",
    },
    {
        name: "Tailwind CSS",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-plain.svg",
    },
    {
        name: "React",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/react/react-original.svg",
    },
    {
        name: "Vue js",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/vuejs/vuejs-original.svg",
    },
    {
        name: "AngularJS",
        link: "https://cdn.jsdelivr.net/npm/devicon@2.10.0/icons/angularjs/angularjs-original.svg",
    },
    {
        name: "Figma",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
    },
];

// backend skills obj
const backend = [
    {
        name: "Node js",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg",
    },
    {
        name: "Express js",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original-wordmark.svg",
    },
    {
        name: "Spring",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original-wordmark.svg",
    },
    {
        name: "GraphQL",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain-wordmark.svg",
    },
    {
        name: "MySQL",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original-wordmark.svg",
    },
    {
        name: "MongoDB",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original-wordmark.svg",
    },
    {
        name: "PostgreSQL",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original-wordmark.svg",
    },
    {
        name: "Docker",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original-wordmark.svg",
    },
    {
        name: "Jenkins",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
    },
    {
        name: "Kubernetes",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain-wordmark.svg",
    },
    {
        name: "Amazon Web Services",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
    },
    {
        name: "Firebase",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain-wordmark.svg",
    },
    {
        name: "Django",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg",
    },
    {
        name: "Flask",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original-wordmark.svg",
    },
];

// Export the objects
export { languages, frontend, backend };
